export default {
  editForm: {
    title: 'Анкета регистрации канала',
    name: 'Внутреннее название канала',
    groupUrl: 'Ссылка на группу VK',
    guaranteeLetter: '<0>Письмо для разрешения рассылки</0> (.pdf)',
    uploadLetter: 'Загрузить письмо',
  },
};
